import React from 'react'
import { makeStyles } from "@material-ui/core";
import { motion, transform } from "framer-motion";
import { Autoplay } from "swiper/modules";
import partnerIcon1 from "../../../images/v4/aiPage/icons/partnerIcon1.svg";
import partnerIcon2 from "../../../images/v4/aiPage/icons/partnerIcon2.svg";
import partnerIcon3 from "../../../images/v4/aiPage/icons/partnerIcon3.svg";
import partnerIcon4 from "../../../images/v4/aiPage/icons/partnerIcon4.svg";
import partnerIcon5 from "../../../images/v4/aiPage/icons/partnerIcon5.svg";
import partnerIcon7 from "../../../images/v4/aiPage/icons/partnerIcon7.svg";
import partnerIcon8 from "../../../images/v4/aiPage/icons/partnerIcon8.svg";
import partnerIcon9 from "../../../images/v4/aiPage/icons/partnerIcon9.svg";
import parterIcon10 from "../../../images/v4/aiPage/icons/partnerIcon10.svg";
import parterIcon11 from "../../../images/v4/aiPage/icons/partnerIcon11.svg";
import parterIcon12 from "../../../images/v4/aiPage/icons/partnerIcon12.svg";
import parterIcon13 from "../../../images/v4/aiPage/icons/partnerIcon13.svg";
import parterIcon14 from "../../../images/v4/aiPage/icons/partnerIcon14.svg";
import parterIcon15 from "../../../images/v4/aiPage/icons/partnerIcon15.svg";
import parterIcon16 from "../../../images/v4/aiPage/icons/partnerIcon16.svg";
import parterIcon17 from "../../../images/v4/aiPage/icons/partnerIcon17.svg";
import parterIcon18 from "../../../images/v4/aiPage/icons/partnerIcon18.svg";
import parterIcon19 from "../../../images/v4/aiPage/icons/partnerIcon19.svg";
import parterIcon20 from "../../../images/v4/aiPage/icons/partnerIcon20.svg";
import parterIcon21 from "../../../images/v4/aiPage/icons/partnerIcon21.svg";


import parterColorIcon1 from "../../../images/v4/aiPage/icons/partnerColorIcon1.svg";
import parterColorIcon2 from "../../../images/v4/aiPage/icons/partnerColorIcon2.svg";
import parterColorIcon3 from "../../../images/v4/aiPage/icons/partnerColorIcon3.svg";
import parterColorIcon4 from "../../../images/v4/aiPage/icons/partnerColorIcon4.svg";
import parterColorIcon5 from "../../../images/v4/aiPage/icons/partnerColorIcon5.svg";
import parterColorIcon7 from "../../../images/v4/aiPage/icons/partnerColorIcon7.svg";
import parterColorIcon8 from "../../../images/v4/aiPage/icons/partnerColorIcon8.svg";
import parterColorIcon9 from "../../../images/v4/aiPage/icons/partnerColorIcon9.svg";
import parterColorIcon10 from "../../../images/v4/aiPage/icons/partnerColorIcon10.svg";
import parterColorIcon11 from "../../../images/v4/aiPage/icons/partnerColorIcon11.svg";
import parterColorIcon12 from "../../../images/v4/aiPage/icons/partnerColorIcon12.svg";
import parterColorIcon13 from "../../../images/v4/aiPage/icons/partnerColorIcon13.svg";
import parterColorIcon14 from "../../../images/v4/aiPage/icons/partnerColorIcon14.svg";
import parterColorIcon15 from "../../../images/v4/aiPage/icons/partnerColorIcon15.svg";
import parterColorIcon16 from "../../../images/v4/aiPage/icons/partnerColorIcon16.svg";
import parterColorIcon17 from "../../../images/v4/aiPage/icons/partnerColorIcon17.svg";
import parterColorIcon18 from "../../../images/v4/aiPage/icons/partnerColorIcon18.svg";
import parterColorIcon19 from "../../../images/v4/aiPage/icons/partnerColorIcon19.svg";
import parterColorIcon20 from "../../../images/v4/aiPage/icons/partnerColorIcon20.svg";
import parterColorIcon21 from "../../../images/v4/aiPage/icons/partnerColorIcon21.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";


export default function TrustedByLogoStrip({title="Best CRM with WhatsApp integration - Trusted by SMEs globally"}) {
    

    const partners = [
    { icon: partnerIcon1,hoverIcon: parterColorIcon1, alt: "Supreme HR recruitment agency using Pepper Cloud CRM" },
    { icon: partnerIcon3,hoverIcon: parterColorIcon3, alt: "Chan Brothers travel company using Pepper Cloud CRM" },
    { icon: partnerIcon2,hoverIcon: parterColorIcon2, alt: "Kristal hospitality brand using Pepper Cloud CRM" },
    { icon: partnerIcon4,hoverIcon: parterColorIcon4, alt: "Mazeed technology company using Pepper Cloud CRM`" },
    { icon: partnerIcon5,hoverIcon: parterColorIcon5, alt: "Bankaool fintech company using Pepper Cloud CRM" },
    {
      icon: partnerIcon7,
      hoverIcon: parterColorIcon7,
      alt: "Urban Mood furniture brand using Pepper Cloud CRM",
    },
    { icon: partnerIcon9,hoverIcon: parterColorIcon9, alt: "HydroBall beverage brand using Pepper Cloud CRM" },
    { icon: partnerIcon8,hoverIcon: parterColorIcon8, alt: "Mandala Club private members club using Pepper Cloud CRM" },
    { icon: parterIcon11,hoverIcon: parterColorIcon11, alt: "TechData - Pepper Cloud Customer" },
    { icon: parterIcon10,hoverIcon: parterColorIcon10, alt: "GetGo car sharing platform using Pepper Cloud CRM" },
    { icon: parterIcon12,hoverIcon: parterColorIcon12, alt: "Nam Ho DMC travel services company using Pepper Cloud CRM" },
    {
      icon: parterIcon13,
      hoverIcon: parterColorIcon13,
      alt: "Siong Door door manufacturer using Pepper Cloud CRM",
    },
    {
      icon: parterIcon14,
      hoverIcon: parterColorIcon14,
      alt: "Caffeine Solutions IT solutions company using Pepper Cloud CRM",
    },
    { icon: parterIcon17, hoverIcon: parterColorIcon17, alt: "Tofu food and beverage brand using Pepper Cloud CRM" },
    { icon: parterIcon15, hoverIcon: parterColorIcon15, alt: "VooTours tourism company using Pepper Cloud CRM" },
    //  { icon: parterIcon18, hoverIcon: parterColorIcon18, alt: "ACMS financial services company using Pepper Cloud CRM" },
    { icon: parterIcon16, hoverIcon: parterColorIcon16, alt: "Mirage Aesthetic aesthetic clinic using Pepper Cloud CRM" },
    // { icon: parterIcon19, hoverIcon: parterColorIcon19, alt: "TechData IT distribution company using Pepper Cloud CRM" },
    // {
    //   icon: parterIcon20,
    //   hoverIcon: parterColorIcon20,
    //   alt: "SMF manufacturing association using Pepper Cloud CRM",
    // },
    {
      icon: parterIcon21,
      hoverIcon: parterColorIcon21,
      alt: "Crowe consulting firm using Pepper Cloud CRM",
    },
  ];

    const useStyles = makeStyles((theme) => ({
          stripSection: {
            backgroundColor: "transparent",
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        
            "& .centerContainer": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
        
            "@media only screen and (max-width: 600px)": {
              "& .centerContainer": {
                textAlign: "center",
              },
            },
          },

         partnerSlider: {
           padding: "10px 0 40px",
           "@media only screen and (max-width: 600px)": {
             paddingBottom: "40px",
           },
         },

         partnerSlide: {
         width: "auto",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",       

         "& .logoWrapper": {
           position: "relative",
           display: "inline-block",
         },       

         "& img": {
           height: "56px",
           width: "auto",
           maxWidth: "100%",
           transition: "opacity 0.3s ease",
         },       

         "& .hoverLogo": {
           position: "absolute",
           top: 0,
           left: 0,
           opacity: 0,
         },       

         "&:hover .hoverLogo": {
           opacity: 1,
         },       

         "&:hover .defaultLogo": {
           opacity: 0,
         },
          "@media only screen and (max-width: 600px)": {
          "& img": {
            height: "36px",
           },
      },
       },
}));
 const classes = useStyles();  

  return (
    <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              {title}
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={80}
          loop={true}
          speed={1700}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 40,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 1700,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <div className="logoWrapper">
                <img src={partner.icon} alt={partner.alt} className="defaultLogo" />
                <img src={partner.hoverIcon} alt={partner.alt} className="hoverLogo" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
  )
}
